import React from 'react'

import FormControl from '@mui/material/FormControl'
import Select, { SelectChangeEvent } from '@mui/material/Select'
import MenuItem from '@mui/material/MenuItem'
import InputLabel from '@mui/material/InputLabel'
import { measurementUnits } from 'enums/units'

export default function UnitsSelect(props: {
  value: string
  onChange: (event: SelectChangeEvent) => void
  options?: string[]
}) {
  const { onChange, value } = props
  const options = props.options ?? Object.keys(measurementUnits)

  return (
    <FormControl variant="outlined" fullWidth style={{ minWidth: '100px' }}>
      <InputLabel id="units-select">Unit</InputLabel>
      <Select
        labelId="units-select"
        label="Unit"
        value={value}
        onChange={onChange}
        fullWidth
      >
        {options.map((option) => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  )
}
